// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1804) return "modules/shared.js";
	// return url for filenames based on template
	return "modules/" + chunkId + ".chunk.js";
};